import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import TabSelector from "./TabSelector";
import { PLACEMENT_TABS, TABS_MO } from "./Tabs";
import { changeAspectRatio } from "reducers/Social";
import { SOCIAL_AD_TYPES } from "utils/constants";

// import "./FacebookSocialTabSelector.css";
import "./FacebookMOSocialTabSelector.css";

export function getClosestAspectRatioName(width, height, aspectRatioHash) {
	/**
	 * image aspect ratios will not always be 100 percent strict
	 * (fb might have x amount of tolerence) so we need to find
	 * the closest one to square, horizontal, or vertical
	 * @param {number} width image width
	 * @param {number} height image height
	 * @param {array} aspectRatioHash nested array of image's aspect ratio
	 * as string and aspect ratio as number -> [["square", 1.33], ["horizontal", 1.91]...]
	 */

	let aspectRatio = width/height;

	let closestAspectRatio
		, closestAspectRatioName;

	const aspRatioHashEntries = Object.entries(aspectRatioHash);

	for(const [index, [key, value]] of aspRatioHashEntries) {
		if(parseInt(index) === 0) {
			closestAspectRatio = value;
			closestAspectRatioName = key;
		}
		let currentDifference = Math.abs(aspectRatio - closestAspectRatio);
		let newDifference = Math.abs(aspectRatio - value);

		if(newDifference < currentDifference) {
			closestAspectRatio = value;
			closestAspectRatioName = key;
		}
	}

	return closestAspectRatioName;
}

const ASPECT_RATIOS_NUMERICAL = {
	square: 1,
	horizontal: 1.91,
	vertical: 0.56,
};

export const aspectRatioHash = Object.entries(ASPECT_RATIOS_NUMERICAL);

export default function FacebookMOSocialTabSelector(props){
	const dispatch = useDispatch();

	const {
		selectedTab,
		adType,
	} = useSelector((state) => {
		return {
			selectedTab: state.social?.selectedTab,
			adType: state.creativeDetails.adType,
		};
	});

	let media
		, width
		, height;

	function getMediaDims(element, mediaType) {
		element.addEventListener("loadedmetadata", () => {
			if(mediaType === "video") {
				width = element.videoWidth;
				height = element.videoHeight;
			} else {
				width = element.naturalWidth;
				height = element.naturalHeight;
			}
			dispatch(changeAspectRatio(getClosestAspectRatioName(width, height, aspectRatioHash)));
		});
	}

	useEffect(() => {
		if(adType === SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO) {
			// eslint-disable-next-line prefer-destructuring
			media = document.getElementsByTagName("video")[0];
			if(media) { getMediaDims(media, "video"); }
		} else if (SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO) {
			// eslint-disable-next-line prefer-destructuring
			media = document.getElementsByTagName("img")[0];
			if(media) { getMediaDims(media, "img"); }
		}
	}, [selectedTab, width, height]);

	return (
		<div className="ft-social-tab-container facebook-preview-better">
			<TabSelector tabs={TABS_MO} className="platform-tabs" />
			<TabSelector tabs={PLACEMENT_TABS} className="placement-tabs" isPlacementTab={true} />
		</div>
	);
}

FacebookMOSocialTabSelector.displayName = "FacebookMOSocialTabSelector";
